
// Todo: Компонент пустой корзины
export const CartEmpty = () => {
    return (
        <>
            <h1>
                Корзина пустая <span>😕</span>
            </h1>
        </>
    )
}
